import React from "react";

const LabelledOutline = ({ id, label, children, className }) => (
  <fieldset
    id={id}
    className={className}
    style={{
      border: "1px solid rgba(0,0,0,0.23)",
      borderRadius: 5,
      padding: "8px 12px 12px",
      margin: "10px 0 0",
      minWidth: 0,
    }}
  >
    <legend
      style={{
        padding: "0 6px",
        fontSize: 12,
        color: "#6b6b6b",
        lineHeight: 1,
      }}
    >
      {label}
    </legend>
    {children}
  </fieldset>
);

export default LabelledOutline;
